import { useState } from 'react';
import Button from '../base/Button';
import { useAppConfig } from '../../hooks/useAppConfig';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const appConfig = useAppConfig();

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
              <img 
                src={appConfig.logo} 
                alt={`${appConfig.name} Logo`} 
                className="w-full h-full object-contain"
              />
            </div>
            <h1 
              className="text-xl sm:text-2xl font-bold bg-gradient-to-r bg-clip-text text-transparent" 
              style={{ 
                fontFamily: 'Pacifico, serif',
                backgroundImage: `linear-gradient(to right, ${appConfig.primaryColor}, ${appConfig.secondaryColor})`
              }}
            >
              {appConfig.name}
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a 
              href="#features" 
              className="text-gray-600 transition-colors cursor-pointer"
              style={{
                ':hover': { color: appConfig.primaryColor }
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = appConfig.primaryColor}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Features
            </a>
            <a 
              href="#gallery" 
              className="text-gray-600 transition-colors cursor-pointer"
              onMouseEnter={(e) => e.currentTarget.style.color = appConfig.primaryColor}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Gallery
            </a>
            <a 
              href="#download" 
              className="text-gray-600 transition-colors cursor-pointer"
              onMouseEnter={(e) => e.currentTarget.style.color = appConfig.primaryColor}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Download
            </a>
          </nav>
          
          {/* Desktop Download Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="outline" size="sm" href="#download">
              Download App
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center text-gray-600 transition-colors cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              color: isMenuOpen ? appConfig.primaryColor : ''
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = appConfig.primaryColor}
            onMouseLeave={(e) => !isMenuOpen && (e.currentTarget.style.color = '')}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4 pt-4">
              <a href="#features" className="text-gray-600 hover:text-indigo-600 transition-colors cursor-pointer" onClick={() => setIsMenuOpen(false)}>Features</a>
              <a href="#gallery" className="text-gray-600 hover:text-indigo-600 transition-colors cursor-pointer" onClick={() => setIsMenuOpen(false)}>Gallery</a>
              <a href="#download" className="text-gray-600 hover:text-indigo-600 transition-colors cursor-pointer" onClick={() => setIsMenuOpen(false)}>Download</a>
              <Button variant="outline" size="sm" href="#download" className="self-start">
                Download App
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
